import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

// import Dpu_alumni from "../thank-you/dpu_alumni/Dpu_alumni";
import Admission_Process from "./admission_process/Admission_Process";
import Banner from "./banner/Banner";
import "./banner/Banner.css";
import Certificate from "./certificate/Certificate";
import Dpu_Mca_Alumini from "./dpu_mca_alumini/Dpu_Mca_Alumini";
import Learn_AI_Tools from "./learn-ai-tools/Learn_AI_Tools";
import Life_After_MBA from "./life-after-mba/Life_After_MBA";
import Mba_Certification from "./mba-certification/Mba_Certification";
import Ranks from "./ranks/Ranks";
import Ready_To_Go from "./ready-to-go/Ready_To_Go";
import Specialzation from "./specialization/Specialzation";
import Who_We_Are from "./who-we-are/Who_We_Are";
import Eligibility_Criteria from "./eligibility-criteria/Eligibility_Criteria";
import Fee_Structure from "./fee-structure/Fee_Structure";
import Universityslider from "./university-partner/Universityslider";
import Maximize_Career_Growth from "./maximize_career_growth/Maximize_Career_Growth";
import All_Universities from "./all_universities/All_Universities";
import WhyOnlineMBA from "./why_online_mba/WhyOnlineMBA";
import NewFeeStructure from "./new_fee_structure/NewFeeStructure";
import FAQ from "./faq/FAQ";
import TalkToCounsellor from "./Talk_to_counsellor/TalkToCounsellor";
import BenefitsSection from "./benefits_section/BenefitsSection";
import Choose_Domain from "./choose-domain/Choose_Domain";
import Alumini_Voices from "./alumini-voices/Alumini_Voices";
import Dpu_Learn_Ai_Tool_Swiper from "./dpu_learn_ai_tool_swiper/Dpu_Learn_Ai_Tool_Swiper";
import Conclusion from "./conclusion/Conclusion";
import Simplidistance from "./simplidistance/Simplidistance";
import FreeCareerCounselling from "./free_counselling/FreeCareerCounselling";
import TopCourseCategories from "./Top_Course_Categories/TopCourseCategories";

function Home() {
  const location = useLocation();

  useEffect(() => {
    if (!location.pathname) return;

    let targetId = "home";

    if (location.pathname.includes("programs")) {
      targetId = "programs";
    } else if (location.pathname.includes("admission_process")) {
      targetId = "admissions";
    } else if (location.pathname.includes("eligibility-criteria")) {
      targetId = "eligibility";
    }

    const el = document.getElementById(targetId);

    if (el) {
      const timer = setTimeout(() => {
        el.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }, 100);

      return () => clearTimeout(timer);
    }
  }, [location.pathname]);

  return (
    <>
      <div id="home">
        <Banner />
      </div>

      {/* <Maximize_Career_Growth /> */}

      <WhyOnlineMBA />

      <Simplidistance />

      {/* <Conclusion /> */}

      <div id="specialization">
        <Choose_Domain />
      </div>

      <FreeCareerCounselling /> 

      <Universityslider />

      <TopCourseCategories />

      <div id="programs">
        <All_Universities />
      </div>

      <BenefitsSection />

      <div id="admissions">
        <Admission_Process />
      </div>

      <Dpu_Learn_Ai_Tool_Swiper />

      <Alumini_Voices />

      {/* <NewFeeStructure /> */}

      <TalkToCounsellor />

      <FAQ />

      {/* <Ranks /> */}

      {/* <Life_After_MBA />

      <div id="programs">
        <Specialzation />
      </div>

      <Learn_AI_Tools />

      <div id="eligibility">
        <Eligibility_Criteria />
      </div>

      <Who_We_Are />

      <Certificate />

      <Dpu_Mca_Alumini />

      <Ready_To_Go />

      <div id="admissions">
        <Admission_Process />
      </div>

      <Fee_Structure />

      <Dpu_Learn_Ai_Tool_Swiper />

      <Dpu_alumni /> */}
    </>
  );
}

export default Home;
